import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { QltTeacher } from '../types';

export const TeacherRepository = Repository<QltTeacher>(qltClient, '/teachers');

export default TeacherRepository;
